import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Overlay from "../Overlay/Overlay";
import './Media.scss'

const MEDIA_TYPES = {
    IMAGE: "image",
    VIDEO: "video",
    AUDIO: "audio"
}

const EXTENSIONS = {
    IMAGE: ["jpg", "gif", "png"],
    VIDEO: ["mp4", "3gp", "ogg"],
    AUDIO: ["mp3", "WAV"]
}

function getTypeFromPath(path) {

    const extension = path.split('.').pop().toLowerCase();

    if (EXTENSIONS.IMAGE.includes(extension))
        return MEDIA_TYPES.IMAGE
    else if (EXTENSIONS.VIDEO.includes(extension))
        return MEDIA_TYPES.VIDEO
    else if (EXTENSIONS.AUDIO.includes(extension))
        return MEDIA_TYPES.AUDIO
    else
        return MEDIA_TYPES.IMAGE
}

const ImageMedia = (props) => {
    const [overlay, setOverlay] = React.useState(false);
    const overlayStyle = {
        display: `flex`,
        height: `85%`,
    }

    const imgStyle = (props.imgStyle !== undefined) ? props.imgStyle : { width: "100%" };
    const content = (
        <figure
            className="image-media-container"
            onClick={() => { setOverlay(true) }}
            style={overlay ? overlayStyle : { cursor: `pointer` }}
        >
            <img src={props.src} alt={props?.alt} style={imgStyle} />
        </figure >
    );

    if (overlay)
        return <Overlay onClose={() => setOverlay(false)}>{content}</Overlay>;
    else
        return content;
}

const Media = (props) => {

    const { variant } = props;

    const type = props.type || getTypeFromPath(props.src);

    const setVariant = (variant) => {
        switch (variant) {
            case 'fill': return 'fill'
            default: return ''
        }
    }

    const getCurrentMedia = () => {
        switch (type) {
            case MEDIA_TYPES.IMAGE:
                return (
                    <ImageMedia src={props.src} alt={props?.alt} imgStyle={props.imgStyle} />
                )
            case MEDIA_TYPES.VIDEO:
                return (
                    <video width="100%"
                        controls id="video-player"
                        autoPlay={true}
                        style={{
                            width: `100%`
                        }}
                        poster='img/video-poster.png' >
                        <source src={props.src} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                )
            case MEDIA_TYPES.AUDIO:
                return (
                    <div className="audio-media-container">
                        <audio controls controls id="video-player" autoPlay={true} >
                            <source src={props.src} type="audio/ogg" />
                            <source src={props.src} type="audio/mpeg" />
                            Your browser does not support the audio tag.
                        </audio>
                    </div>
                )
            default:
                break;
        }
    }

    return (
        <div className={`media-container ${setVariant(variant)}`} style={props.style} className={props.className}>
            {(props && props.caption) &&
                <Caption>{props.caption}</Caption>
            }

            {getCurrentMedia()}
        </div>
    );
}

export default Media;

const Caption = styled.span`
    display: inline-block;
    margin:20px auto 10px;
    width: 100%;
    display: inline-block;
    color:#fff;
    padding:10px 15px;
    font-size: 0.8em !important;
    font-weight: bold;
    text-align: center;
    display: block;
`
